import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingBag, ArrowLeft, MessageCircle, Sparkles } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { Button } from './ui/button';
import { trackEvent } from '../lib/analytics';

const CollectionHeader = () => {
  const { cartCount, phoneNumber } = useCart();
  const location = useLocation();
  const isCartPage = location.pathname.includes('/cart');

  return (
    <header className="sticky top-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-md border-b border-rose-100 shadow-sm transition-all duration-300">
      <div className="container mx-auto px-4 py-3 sm:py-4">
        <div className="flex items-center justify-between gap-3">
          {/* Logo / Brand */}
          <div className="flex items-center space-x-3">
            <Link to="/" className="flex items-center space-x-2 group">
              <img
                src="/logo.png"
                alt="Makeup By Khushi Logo"
                className="h-10 sm:h-12 w-auto object-contain transition-transform group-hover:scale-105"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = './logo.png';
                }}
              />
              <div className="flex flex-col leading-tight">
                <span className="text-lg sm:text-xl font-serif font-bold text-rose-700 tracking-wide group-hover:text-rose-800 transition-colors">
                  Khushi Shukla
                </span>
                <span className="text-[11px] sm:text-xs text-rose-500 font-medium tracking-wider uppercase">
                  Jewellery & Collection
                </span>
              </div>
            </Link>
          </div>

          {/* Navigation & Action Buttons */}
          <div className="flex items-center space-x-2 sm:space-x-3">
            <Link
              to="/"
              className="hidden md:inline-flex items-center text-sm font-medium text-stone-600 hover:text-rose-600 transition-colors px-2 py-1"
            >
              <ArrowLeft className="w-4 h-4 mr-1" />
              Main Website
            </Link>

            {isCartPage ? (
              <Link to="/my-collection">
                <Button
                  variant="outline"
                  size="sm"
                  className="border-rose-200 text-stone-700 hover:bg-rose-50 hover:text-rose-600 text-xs sm:text-sm"
                >
                  <ArrowLeft className="w-3.5 h-3.5 mr-1" />
                  Continue Browsing
                </Button>
              </Link>
            ) : (
              <Link 
                to="/cart"
                onClick={() => {
                  trackEvent('view_cart_click', { source: 'header_button', items_in_cart: cartCount });
                }}
              >
                <Button
                  variant={cartCount > 0 ? "default" : "outline"}
                  size="sm"
                  className={`relative text-xs sm:text-sm transition-all duration-200 ${
                    cartCount > 0
                      ? 'bg-rose-600 hover:bg-rose-700 text-white shadow-md'
                      : 'border-rose-200 text-stone-700 hover:bg-rose-50 hover:text-rose-600'
                  }`}
                >
                  <ShoppingBag className="w-4 h-4 mr-1.5" />
                  <span>Cart</span>
                  {cartCount > 0 && (
                    <span className="ml-1.5 px-1.5 py-0.2 bg-white text-rose-700 font-bold text-xs rounded-full shadow-sm animate-pulse">
                      {cartCount}
                    </span>
                  )}
                </Button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default CollectionHeader;
